import { connect } from 'react-redux'

import { getActiveUser } from 'app/fieldapp/store/users/selectors'

import { ProfilePage, ProfilePageProps } from './ProfilePage'

type ReduxSelectors = 'getActiveUser'

type StateProps = Pick<ProfilePageProps, ReduxSelectors>
type DispatchProps = unknown
type PassThruProps = Omit<ProfilePageProps, ReduxSelectors>

const mapStateToProps = state => ({
  getActiveUser: () => getActiveUser(state),
})

export const ConnectedProfilePage = connect<
  StateProps,
  DispatchProps,
  PassThruProps
>(
  mapStateToProps,
  {},
)(ProfilePage)
